import { CenteringDiv, FlexRowDiv, H1, H3 } from 'components/generic/HomePageComponents'
import { InlineContainer, HeroSubtitle, HeroButton } from './Styled'
import { TrackEvent } from 'utils/Analytics'

const HeroContainer = ({
  heroHeading,
  heroSubHeading,
  findProviderButtonText,
  heroLink,
  seekerLookingFor,
}) => {
  const onHeroButtonClick = () => {
    TrackEvent('cta_click', { cta_type: 'homepage_hero_button' })
  }
  return (
    <FlexRowDiv bg='inverseColor'>
      <CenteringDiv mt={['170px', '170px', '140px', '140px']} ml='30px' mr='30px'>
        <H1 color='white' mb='0px' textAlign={['left', 'left', 'center', 'center']}>
          {heroHeading}
        </H1>
        <H3
          color='white'
          mb='0px'
          mt='11px'
          width={['auto', 'auto', 'auto', '43%']}
          textAlign={['left', 'left', 'center', 'center']}
        >
          {heroSubHeading}
        </H3>
        <HeroButton
          onClick={onHeroButtonClick}
          href={heroLink}
          fontSize={['16px', '18px', '24px']}
          rel='nofollow'
        >
          {findProviderButtonText}
        </HeroButton>
        <InlineContainer border='1px red solid'>
          <HeroSubtitle
            color='white'
            mb={['40px', '40px', '40px', '90px']}
            maxWidth={['350px', '350px', '70vw']}
            textAlign={['left', 'left', 'center', 'center']}
            dangerouslySetInnerHTML={{ __html: seekerLookingFor }}
          />
        </InlineContainer>
      </CenteringDiv>
    </FlexRowDiv>
  )
}

export default HeroContainer
